import { render } from "./LoginRoleView.vue?vue&type=template&id=7cc35c49"
import script from "./LoginRoleView.vue?vue&type=script&lang=js"
export * from "./LoginRoleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__